<template>
  <b-card class="support-page">
    <header class="support-page__head">
      <h3 class="support-page__title">پکیج پشتیبانی</h3>
      <p class="support-page__subtitle">اتصال زبان‌آموز به پشتیبان، ثبت زمان تماس، گزارش و نظرات اساتید</p>
    </header>

    <SupportPackageTabs class="mb-2" :counts="counts" />

    <section>
      <h4 class="support-page__section-title">{{ current.title }}</h4>
      <p class="support-page__section-hint">{{ current.hint }}</p>

      <SupportWaitingList v-if="tab === 'waiting'" @changed="loadCounts" />
      <SupportActiveList v-else-if="tab === 'active'" @changed="loadCounts" />
      <SupportReport v-else-if="tab === 'report'" />
      <SupportComments v-else />
    </section>
  </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import SupportPackageTabs from "./SupportPackageTabs.vue";
import SupportWaitingList from "./SupportWaitingList.vue";
import SupportActiveList from "./SupportActiveList.vue";
import SupportReport from "./SupportReport.vue";
import SupportComments from "./SupportComments.vue";
import { GetSupportAdminList, SUPPORT_STATUS } from "@/libs/Api/SupportLesson";

export default {
  name: "SupportPackages",
  components: { BCard, SupportPackageTabs, SupportWaitingList, SupportActiveList, SupportReport, SupportComments },
  props: {
    // waiting | active | report | comments (از route)
    tab: { type: String, default: "waiting" },
  },
  data() {
    return {
      counts: {},
      sections: {
        waiting: {
          title: "درخواست‌های جدید پشتیبانی",
          hint: "پکیج‌های پرداخت‌شده؛ برای هر کدام یک پشتیبان انتخاب و وصل کنید.",
        },
        active: {
          title: "تماس‌های در حال انجام",
          hint: "بعد از هر تماس، مدت آن را به دقیقه ثبت کنید.",
        },
        report: {
          title: "گزارش پشتیبان‌ها",
          hint: "زمان، مبلغ دریافتی، حقوق پشتیبان و سود؛ به تفکیک پشتیبان و زبان‌آموز.",
        },
        comments: {
          title: "نظرات اساتید",
          hint: "نظرهایی که پشتیبان‌ها برای هر زبان‌آموز روی درس‌های پکیج ثبت کرده‌اند.",
        },
      },
    };
  },
  computed: {
    current() {
      return this.sections[this.tab] || this.sections.waiting;
    },
  },
  mounted() {
    this.loadCounts();
  },
  methods: {
    // تعداد هر تب از total همان لیست
    async loadCounts() {
      const totalOf = async (status) => {
        let total;
        const req = new GetSupportAdminList(this);
        req.setRequestParam({ count: 1, pageNumber: 1, status });
        await req.get((res) => {
          total = Number((res && res.data && res.data.total) || 0);
        });
        return total;
      };
      try {
        const [waiting, active] = await Promise.all([totalOf(SUPPORT_STATUS.payed), totalOf(SUPPORT_STATUS.assigned)]);
        this.counts = { waiting, active };
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
.support-page__head {
  margin-bottom: 1rem;
}

.support-page__title {
  margin-bottom: 0.25rem;
  font-weight: 700;
}

.support-page__subtitle,
.support-page__section-hint {
  margin-bottom: 0;
  font-size: 0.85rem;
  color: #82868b;
}

.support-page__section-title {
  margin-bottom: 0.25rem;
  font-size: 1.05rem;
  font-weight: 700;
}

.support-page__section-hint {
  margin-bottom: 1rem;
}
</style>
